var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "group1 flex-col"
  }, [_c("div", {
    staticClass: "main2 flex-row justify-between",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    },
    on: {
      click: _vm.back
    }
  }), _c("span", {
    staticClass: "info1"
  }, [_vm._v("New MG Extender_GC")])])]), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mod1 flex-col"
  }, [_c("div", {
    staticClass: "section1 flex-col"
  }, [_c("img", {
    staticClass: "img1",
    attrs: {
      referrerpolicy: "no-referrer",
      src: "https://tpage.soimt.com/APP/SNS/brochure_dc.png"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };